<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String
    },
    text: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'radioBox'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'type'
    },
    value: {
      type: [Array, String, Number, Boolean]
    },
    inline: {
      type: Boolean,
      default: false
    },
    modelValue: {
      default: ""
    },
    type: {
      type: String,
      default: "radio"
    }
  },
  methods: {
    updateInput() {
      this.$emit('change', this.value)
    }
  }

}
</script>

<template>
  <div>
    <label :for="id" class="radio-box w-100 mb-0" :class="{'radio-box--disabled': disabled, 'radio-box--inline': inline}">
      <input v-if="type === 'checkbox'" :id="id" :name="name" type="checkbox" class="radio-box__input" @change="updateInput" :checked="modelValue" :disabled="disabled" />
      <input v-else-if="type === 'radio'" :id="id" :name="name" :value="value" type="radio" class="radio-box__input" @change="updateInput" :checked="modelValue === value" :disabled="disabled" />
      <div class="card radio-box__card">
        <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary radio-box__icon" v-if="icon">
          <div class="avatar-title rounded-circle">
            <i :class="`bx ${icon} font-size-24`" />
          </div>
        </div>
        <span class="radio-box__button"></span>
        <div class="card-body radio-box__text-wrapper">
          <b-card-title v-if="title">
            <h5 class="card-title">{{ title }}</h5>
          </b-card-title>
          <p class="radio-box__text" v-if="text" v-html="text">
          </p>
        </div>
      </div>
    </label>
  </div>
</template>
